<kendo-dialog title="{{header}}" *ngIf="dialogOpened" (close)="close('dialog')" [minWidth]="300" [width]="630">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <p>{{message}}</p>
  <div class="d-flex mt-3 align-items-center">
    <label class="me-3">
      {{'_General_Location_Text_' | translate }}:
    </label>
    <app-location-selector class="location-selector w-75" [selectedLocationId]="locationId"
      [selectedLocationName]="locationName" (onChange)="locationChange($event)" [isDisableParentClick]="true"
      [isIncludeFloatLocation]="false" [selectableTypes]="[5]" [selectorDisabled]="selectorDisabled"
      [dispatchStateEvent]="false" [hideBranchLess]="true" [isLobby]="true">
    </app-location-selector>
  </div>
  <kendo-dialog-actions *ngIf="isInfo==true" class="cc-btn-panel">
    <button class="btn btn-primary" (click)="action('yes')" primary="true">{{actionYesLabel}}</button>
  </kendo-dialog-actions>

  <kendo-dialog-actions *ngIf="isInfo==false" class="cc-btn-panel">
    <button class="btn btn-secondary" (click)="emitCancel('no')">{{actionNoLabel}}</button>
    <button class="btn btn-primary" (click)="emitSubmit('yes')" primary="true">{{actionYesLabel}}</button>
  </kendo-dialog-actions>
</kendo-dialog>
